import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-323b3594"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "custom-hideItems" }
const _hoisted_2 = { class: "custom-hideItems__wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "custom-hideItems__wrapper__title" }, "展示功能入口", -1))

import { NSpace, NCheckbox } from 'naive-ui'
import { ref } from 'vue'
interface Emits {
  (e: 'teamMemoryCheckedChange', checkedValue: boolean): void
  (e: 'memberAvatarCheckedChange', checkedValue: boolean): void
  (e: 'messageNotificationCheckedChange', checkedValue: boolean): void
  (e: 'sharingTeamCheckedChange', checkedValue: boolean): void
}
interface Props {
  teamMemoryChecked: boolean
  memberAvatarChecked: boolean
  messageNotificationChecked: boolean
  sharingTeamChecked: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'customHide',
  props: {
    teamMemoryChecked: { type: Boolean },
    memberAvatarChecked: { type: Boolean },
    messageNotificationChecked: { type: Boolean },
    sharingTeamChecked: { type: Boolean }
  },
  emits: ["teamMemoryCheckedChange", "memberAvatarCheckedChange", "messageNotificationCheckedChange", "sharingTeamCheckedChange"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'teamMemoryCheckedChange', checkedValue: boolean): void
  (e: 'memberAvatarCheckedChange', checkedValue: boolean): void
  (e: 'messageNotificationCheckedChange', checkedValue: boolean): void
  (e: 'sharingTeamCheckedChange', checkedValue: boolean): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  teamMemoryChecked: boolean
  memberAvatarChecked: boolean
  messageNotificationChecked: boolean
  sharingTeamChecked: boolean
}



//  12.20 暂时屏蔽空间容量
// const teamMemoryChecked = ref(props.teamMemoryChecked)
const memberAvatarChecked = ref(props.memberAvatarChecked)
const messageNotificationChecked = ref(props.messageNotificationChecked)
const sharingTeamChecked = ref(props.sharingTeamChecked)
//  12.20 暂时屏蔽空间容量
// const handleSpaceCapacityCheckedChange = (value: boolean) => {
//   teamMemoryChecked.value = value
//   emits('teamMemoryCheckedChange', value)
// }

const handleMemberAvatarCheckedChange = (value: boolean) => {
  memberAvatarChecked.value = value
  emits('memberAvatarCheckedChange', value)
}

const handleMessageNotificationCheckedChange = (value: boolean) => {
  messageNotificationChecked.value = value
  emits('messageNotificationCheckedChange', value)
}

const handleSharingTeamCheckedChange = (value: boolean) => {
  sharingTeamChecked.value = value
  emits('sharingTeamCheckedChange', value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_unref(NSpace), {
        vertical: "",
        size: 8
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(NCheckbox), {
            value: "MemberAvatar",
            label: "空间成员",
            class: "icon-checkbox",
            checked: memberAvatarChecked.value,
            onUpdateChecked: handleMemberAvatarCheckedChange
          }, null, 8, ["checked"]),
          _createVNode(_unref(NCheckbox), {
            value: "MessageNotification",
            label: "消息通知",
            class: "icon-checkbox",
            checked: messageNotificationChecked.value,
            onUpdateChecked: handleMessageNotificationCheckedChange
          }, null, 8, ["checked"]),
          _createVNode(_unref(NCheckbox), {
            value: "SharingTeam",
            label: "分享空间",
            class: "icon-checkbox",
            checked: sharingTeamChecked.value,
            onUpdateChecked: handleSharingTeamCheckedChange
          }, null, 8, ["checked"])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})